import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'

import { Observable, catchError } from 'rxjs'

import { environment } from '../../environments/environment'

import { ErrorService } from './error.service'

import { RootInjectorGuard } from '../guards/root-injector.guard'
import { ComponentAutoCompleteResult } from '../types/components'

@Injectable({
  providedIn: 'root',
})
export class ComponentService extends RootInjectorGuard {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'products'

  constructor() {
    super(ComponentService)
  }

  /**
   * Calls the autocomplete component filter API
   * @param {string} keyword Keyword
   */
  autoCompleteComponents(
    keyword: string,
  ): Observable<ComponentAutoCompleteResult[]> {
    let params = new HttpParams()

    params = params.set('name', keyword)
    params = params.set('limit', 100)

    return this.http
      .get<ComponentAutoCompleteResult[]>(`${this.URL}/autocomplete`, {
        params: params,
      })
      .pipe(catchError(this.errorService.handleError))
  }
}
